"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabSearch = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TabContext_1 = require("./TabContext");
const elements_1 = require("../../elements");
const hooks_1 = require("../../hooks");
const debounce_1 = (0, tslib_1.__importDefault)(require("lodash/debounce"));
const TabSearch = ({ onChange, debounceWait = 200, }) => {
    const { state, setState } = (0, react_1.useContext)(TabContext_1.TabContext);
    const dispatchOnChange = (0, react_1.useMemo)(() => {
        return (0, debounce_1.default)((searchTerm) => {
            if (onChange)
                onChange(searchTerm);
        }, debounceWait);
    }, [onChange, debounceWait]);
    const handleKeyPress = (0, react_1.useCallback)((event) => {
        if (state.searchTerm === undefined)
            setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: '' })));
    }, [setState, state]);
    const handleBtnClick = (0, react_1.useCallback)(() => {
        setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: '' })));
    }, [setState]);
    (0, hooks_1.useEventListener)('keypress', handleKeyPress);
    const handleSearchChange = (0, react_1.useCallback)((search) => {
        const searchTerm = search.toString();
        if (searchTerm === '') {
            setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: undefined })));
        }
        else {
            setState((state) => (Object.assign(Object.assign({}, state), { searchTerm })));
        }
        dispatchOnChange(searchTerm);
    }, [setState]);
    const handleCancelSearch = (0, react_1.useCallback)(() => {
        dispatchOnChange(undefined);
        setState((state) => (Object.assign(Object.assign({}, state), { searchTerm: undefined })));
    }, [setState]);
    if (state.searchTerm !== undefined) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "tabs__search" }, { children: [(0, jsx_runtime_1.jsx)(elements_1.Input, { value: state.searchTerm, onChange: handleSearchChange, icon: "search", autoFocus: true }, void 0), (0, jsx_runtime_1.jsx)(elements_1.Button, Object.assign({ base: true, className: "ml--1", onClick: handleCancelSearch }, { children: "Cancel" }), void 0)] }), void 0));
    }
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "tabs__search-btn", onClick: handleBtnClick }, { children: [(0, jsx_runtime_1.jsx)(elements_1.Icon, { name: "search", className: "mr--0_5" }, void 0), "Start typing to search"] }), void 0));
};
exports.TabSearch = TabSearch;
//# sourceMappingURL=TabSearch.js.map